import { Box, Breadcrumbs, Button, Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { setEditQuestion, stateRefresh, stateValues } from '../../slices/inPlaySlice';
import { useDispatch, useSelector } from "react-redux";
import { AiFillCloseCircle } from 'react-icons/ai';
import { CHANGESTATUS, INPLAY, SUSPENDINPLAY } from "../../constant/endpoint";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MdNavigateNext } from "react-icons/md";
import Swal from "sweetalert2";

export const SuspendInPlay = ({}) => {

    const predictionState = useSelector((state) => state.inPlaySlice);
    const { match_id, series_id, sport , pred_id} = useParams()
    const dispatch = useDispatch();
    const setQuestion = (e) => {      
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }
    const [currentData, setCurrentData] = useState("");
    const handleSuspendEnter = async (event, data) => {
        // let req = { match_id, series_id, _id:data._id, over_runs: data.over_runs, under_runs: data.over_runs - 2 }
        // if (data.suspend == true && event.key !== "Enter") {
        //     event.preventDefault();
        // }
       
        if (event.key == "Enter") {
            if ( data.over_runs > 999) {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Over Runs Should be less than 999",
                    showConfirmButton: false,
                    timer: 1500,
                });
                return;
            }
            else if ((data.over_runs - data.difference) < 1) {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Under Runs should be atleast 1",
                    showConfirmButton: false,
                    timer: 1500,
                });
                return;
            }
            let req = {
                match_id, series_id, _id: data._id, over_runs: data.over_runs, under_runs: data.over_runs - data.difference, suspend: false
            }
            await axios.post(SUSPENDINPLAY, req)
            const inPlayData = {
                ...data,
                suspend: false,
            };
            dispatch(setEditQuestion(inPlayData));
        }
        // else if (event.key == "Enter" && data.suspend == true) {
        //     let req = {
        //         match_id, series_id, _id: data._id, suspend: "false", over_runs: data.over_runs, under_runs: data.over_runs - data.difference
        //     }
        //     await axios.post(SUSPENDINPLAY, req)
        //     const inPlayData = {
        //         ...data,
        //         suspend: false,
        //     };
        //     dispatch(setEditQuestion(inPlayData));
        //     // getOpinionTrading()
        // }
        // if (event.key == "Tab" && data.suspend == false) {
        //     updateSuspendDetails(data, true)
        // }
    }

    const updateSuspendDetails = async (data, suspend) => {
        if (data.over_runs > 999) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Over Runs Should be less than 999",
                showConfirmButton: false,
                timer: 1500,
            });
            return;
        }
       else if ((data.over_runs - data.difference) < 1) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Under Runs should be atleast 1",
                showConfirmButton: false,
                timer: 1500,
            });
            return;
        }
        let req = { match_id, series_id, _id:data._id, over_runs: data.over_runs, under_runs: data.over_runs >= data.difference ?  data.over_runs - data.difference : 0 }
            req["suspend"] = suspend
        await axios.post(SUSPENDINPLAY, req)
        const inPlayData = {
            ...data,
            suspend: suspend ,
        };
        dispatch(setEditQuestion(inPlayData));
        // getOpinionTrading()
    }
    const getOpinionTrading = async () => {
        const response = await axios.get(INPLAY.replace(':match_id', match_id).replace(':series_id', series_id))
        // setLoading(true)
        if (response?.data?.status)  {
            setCurrentData(getPredId(response.data.data))
            dispatch(setEditQuestion(getPredId(response.data.data)));
            // setLoading(false)
        }
    }

    const getPredId = (arr) => {
        let data = {}
         data = arr.find((pre) => pre._id === pred_id)
        return data
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>,<Link underline="hover"
            color="inherit"  to={`/matchlist/in_play/${match_id}/${series_id}/1`} >
            <h5>{'QUIZ PLAY'}</h5>
        </Link>,
        <h5>{ pred_id}</h5>
    ];
    const questionStatus = async () => {
        let data;
        let status = predictionState?.questionStates?.status
        let predInfo = predictionState?.questionStates
        let _id = predInfo._id
        if (status) {
            data = { status: 0, match_id, series_id, _id }
        } else {
            data = { status: 1, match_id, series_id, _id }
        }
        if (data.status === 1 && predInfo.is_over_under && predInfo.over_runs <= 0) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Please Enter Over Runs",
                showConfirmButton: false,
                timer: 1500,
            });
            return;
        }
        await axios.post(CHANGESTATUS, data)
        getOpinionTrading()
    }

    useEffect(() => {   
         getOpinionTrading()
     }, [])
    
    
    return (
        // <Dialog open={isOpenSuspend} >
             <center>
                <Box style={{ padding: "20px 80px", margin:"80px 0 0 0" }}>
                <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>Suspend Question</h2>
                        </Grid>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={4}>
                                <h4> {predictionState.questionStates._id && 'Pred id-'}  {predictionState?.questionStates?._id}</h4>
                        </Grid>
                            <Grid item xs={4}>
                                <h4 style={{wordBreak: "break-all"}}>{`Question English : ${predictionState?.questionStates?.question_english}`}</h4>
                        </Grid>

                        <Grid xs={12} item mb={2}>
                        <Button variant={'contained'} size={'large'} color={predictionState?.questionStates?.status ? 'success' : 'error'} onClick={() => questionStatus()} >{predictionState?.questionStates?.status ? 'Active' : 'InActive'}</Button>
                    </Grid>
                        
                        </Grid>
                    </Grid>
                    <hr />
               
             <Grid container style={{justifyContent:"start"}}>
                    <Grid xs={3} item  >
                                            <label>Over Runs</label>
                                            <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'over_runs'} onChange={setQuestion} value={predictionState.questionStates.over_runs} onKeyDown={(event)=>{handleSuspendEnter(event, predictionState.questionStates)}} />
                    </Grid>
                    <Grid xs={3} item mt={2}>
                    <Button variant={'contained'} size={"large"} color={predictionState.questionStates.suspend ? 'error' : 'info'}  onClick={()=>{updateSuspendDetails(predictionState.questionStates, !predictionState.questionStates.suspend )}}>Suspend</Button>
                    </Grid>
                    <Grid xs={3} item>
                                            <label>Under Runs</label>
                                            <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'under_runs'}  value={predictionState.questionStates.over_runs >= predictionState.questionStates.difference ?  predictionState.questionStates.over_runs-predictionState.questionStates.difference : 0}  />
                    </Grid>
                  
                  
                    
                </Grid>
               
                   
                   
                </Box>
                </center>
          
        // </Dialog>
    )
}